/** Trigger a browser download for the given blob data. Throws on empty data. */
export function downloadBlob(data: BlobPart, filename: string): void {
  const sanitizedFilename = filename.replace(/[^a-zA-Z0-9.-]/g, '_');

  const blob = data instanceof Blob ? data : new Blob([data]);
  if (blob.size === 0) {
    throw new Error('Invalid or empty file');
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = sanitizedFilename;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    try {
      document.body.removeChild(link);
    } finally {
      URL.revokeObjectURL(url);
    }
  }, 100);
}
